export const LICENSE_TYPES_INDEX_TOUR = {
  id: "license_types_index",
  steps: [
    {
      element: '[data-tour="license-types-create"]',
      popover: {
        title: "Novo tipo de licença",
        description:
          "Tipos de licença são globais da conta e podem ser usados em vários planos e integrações.",
        side: "bottom",
      },
    },
    {
      element: '[data-tour="license-types-list"]',
      popover: {
        title: "Tipos cadastrados",
        description: "Chave, label e unidade de cada tipo de licença.",
        side: "top",
      },
    },
  ],
};
